export const PRODUCT_DETAILS = 'PRODUCT_DETAILS'



// WEBPACK FOOTER //
// ./src/pages/wx-member/points-mall/payment-details/store/mutations-types.js